import { useQuery } from '@tanstack/react-query';
import { api } from 'shared/api/client';
import { lockKeys } from './keys';

export const useGetCurrentLock = (documentSuperId?: string, sectionSuperId?: string) => {
  return useQuery({
    queryKey: lockKeys.current(documentSuperId, sectionSuperId),

    queryFn: async () => {
      const { data } = await api.GET('/locks/{documentSuperId}/{sectionId}', {
        params: { path: { documentSuperId: Number(documentSuperId), sectionId: sectionSuperId as string } },
      });
      return data;
    },

    enabled: !!documentSuperId && !!sectionSuperId,
  });
};
